import { render } from "./EasySolution.vue?vue&type=template&id=20f5276b"
import script from "./EasySolution.vue?vue&type=script&lang=js"
export * from "./EasySolution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__